import debounce from 'lodash/debounce';

export default {
  methods: {
    fetchItems() {
      this.$store.dispatch(`${this.store}/fetchItems`);
    },

    fetchItemsDebounced: debounce(function() {
      this.fetchItems();
    }, 500)
  }
};
